import * as React from "react";
import { resolveDiagramSvgHeight } from "../shared/diagramSvgDimensions";


import { CardiometabolicAppetiteControlDiagramContent } from "./CardiometabolicAppetiteControlDiagram";
import { CardiometabolicAppetiteControlKeyContent } from "./CardiometabolicAppetiteControlKey";

const SvgCardiometabolicAppetiteControlDiagramKey = ({
  geneColors = {},
  expectedSnps = {},
  showKey = true,
  keyControlsId = "diagram-key",
  onGeneClick,
  width: widthProp,
  height: heightProp,
  ...props
}) => {
  const diagramOnly = !showKey;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      width={widthProp ?? 1024}
      height={resolveDiagramSvgHeight(heightProp, diagramOnly, 1288, 1504)}
      viewBox={diagramOnly ? "0 142 1024 1288" : "0 0 1024 1504"}
    >
      <g id="cardiometabolic-appetite-control-diagram+key" clipPath="url(#clip0_18293_231779)">
        <rect width={1024} height={diagramOnly ? 1288 : 1504} fill="white" />
        {showKey && (
          <g id={keyControlsId}>
            <CardiometabolicAppetiteControlKeyContent />
          </g>
        )}
        <g transform={showKey ? `translate(0 74)` : undefined}>
          <CardiometabolicAppetiteControlDiagramContent
            geneColors={geneColors}
            expectedSnps={expectedSnps}
            onGeneClick={onGeneClick}
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18293_231779">
          <rect width={1024} height={1504} fill="white" />
        </clipPath>
        <clipPath id="clip1_18293_231779">
          <rect width={1024} height={1288} fill="white" transform="translate(0 142)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SvgCardiometabolicAppetiteControlDiagramKey;
